<div style="width: 448px; min-height: 500px; margin: 0 auto">
  <table>
    <tbody>
      <tr>
        <td>
          <form (submit)="userExists($event)">
            <div
              class="bg-white"
              style="
                padding: 2rem 2rem 3rem;
                width: 448px;
                min-height: 326px;
                border-radius: 0.5rem;
                border: 1px solid #ccc;
              "
            >
              @if (errorMessageText()) {
                <div class="alert border border-danger text-danger mb-3 d-flex align-items-center">
                  <span class="fa fa-exclamation-circle mr-3"></span>
                  <span>{{ errorMessageText() }}</span>
                </div>
              }
              <h1 class="pb-sm-4 text-black">Confirm Identity</h1>
              <p>Please enter your username to receive an email with a one-time code.</p>
              <div class="form-group">
                <label
                  class="text-black font-weight-bold mb-2"
                  for="username"
                >
                  Username
                </label>
                <input
                  id="username"
                  class="form-control"
                  [formField]="confirmIdentityForm.username"
                  autocomplete="off"
                />
              </div>
              <div class="d-flex justify-content-center">
                <button
                  type="submit"
                  class="btn btn-success mr-3"
                  [disabled]="confirmIdentityForm.username().invalid() || isLoading()"
                >
                  Continue
                  @if (isLoading()) {
                    <div
                      class="spinner-border spinner-border-sm ml-1"
                      role="status"
                    >
                      <span class="sr-only">Loading...</span>
                    </div>
                  }
                </button>
                <button
                  type="button"
                  class="btn btn-dark ml-3"
                  (click)="returnToLogin()"
                  [disabled]="isLoading()"
                >
                  Cancel
                </button>
              </div>
              <div class="pt-2 mt-3 border-top text-muted small">
                <span>Email with OTP code may take up to 3-4 minutes to be sent.</span>
              </div>
              <div class="pt-2 mt-2 border-top text-muted small">
                <span>
                  After a code has been sent 3 times without OTP code being entered, the account
                  will be blocked, please email
                  <a href="mailto:Fidelityloginsupport@fmr.com">Fidelityloginsupport&#64;fmr.com</a>
                  to unblock account.
                </span>
              </div>
            </div>
          </form>
        </td>
      </tr>
    </tbody>
  </table>
</div>
